// extracted by mini-css-extract-plugin
export default {"fileContainer":"Documents_fileContainer__7hQPr"};